import useUserContext from 'shared/users/contexts/useUserContext'
import { CopilotProvider } from './CopilotProvider'
import { Launcher } from './components/Launcher'

export function CopilotMount() {
  const { user } = useUserContext()
  if (user?.copilotEnabled !== true) return null
  return (
    <CopilotProvider>
      <Launcher />
    </CopilotProvider>
  )
}
